// ── Reference data ───────────────────────────────────────────────────────
export interface Country {
  id: number;
  name: string;
  name_en?: string;
  name_ar?: string;
  code: string;
  is_active: boolean | number;
}

export interface VisaType {
  id: number;
  name: string;
  name_en?: string;
  name_ar?: string;
  description?: string | null;
  description_en?: string | null;
  description_ar?: string | null;
  is_active: boolean | number;
}

// ── Documents ────────────────────────────────────────────────────────────
export interface VisaDocument {
  id?: number;
  visa_pack_id?: number;
  document_name_en: string;
  document_name_ar?: string | null;
  document_name?: string; // accessor renvoyé par le backend (name_{locale})
  priority: number;
  created_at?: string;
  updated_at?: string;
}

// ── Full visa pack object, as returned by the API ──────────────────────────
export interface VisaPack {
  id: number;
  name_en: string;
  name_ar?: string | null;
  description_en?: string | null;
  description_ar?: string | null;

  // Foreign keys
  destination_country_id: number;
  visa_type_id: number;

  // Pricing
  visa_issue_type: string;
  price: number;
  currency: string;

  // Durations & conditions
  processing_time_en: string;
  processing_time_ar?: string | null;
  visa_validity_en: string;
  visa_validity_ar?: string | null;
  stay_validity_en: string;
  stay_validity_ar?: string | null;
  entry_type: string;
  visa_detail_en?: string | null;
  visa_detail_ar?: string | null;

  // Status
  is_active: boolean;

  // Relations
  destination_country?: Country;
  nationalities?: Country[]; // relation N-à-N — remplace l'ancien nationality_id / living_in_id
  visa_type?: VisaType;
  documents?: VisaDocument[];

  // Timestamps
  created_at?: string;
  updated_at?: string;
}

// ── Form data used by Add/Edit pack pages ───────────────────────────────────
export interface VisaPackFormData {
  name_en: string;
  name_ar: string;
  description_en: string;
  description_ar: string;
  destination_country_id: string | number;
  nationality_ids: (string | number)[];
  visa_type_id: string | number;
  visa_issue_type: string;
  price: string | number;
  currency: string;
  processing_time_en: string;
  processing_time_ar: string;
  visa_validity_en: string;
  visa_validity_ar: string;
  stay_validity_en: string;
  stay_validity_ar: string;
  entry_type: string;
  visa_detail_en: string;
  visa_detail_ar: string;
  is_active: boolean;
  documents: VisaDocument[];
}

export const EMPTY_VISA_PACK_FORM: VisaPackFormData = {
  name_en: "",
  name_ar: "",
  description_en: "",
  description_ar: "",
  destination_country_id: "",
  nationality_ids: [],
  visa_type_id: "",
  visa_issue_type: "eVisa",
  price: "",
  currency: "OMR",
  processing_time_en: "",
  processing_time_ar: "",
  visa_validity_en: "",
  visa_validity_ar: "",
  stay_validity_en: "",
  stay_validity_ar: "",
  entry_type: "Single Entry",
  visa_detail_en: "",
  visa_detail_ar: "",
  is_active: true,
  documents: [],
};

// ── Public search filters (destination + nationality) ───────────────────────
export interface VisaSearchParams {
  destination_country_id: string | number;
  nationality_id: string | number;
  nationality_name?: string;
}